import IncidentOpenIncidentsAtAGlanceGraph from './IncidentOpenIncidentsAtAGlanceGraph';

export default IncidentOpenIncidentsAtAGlanceGraph;
